import { initializeApp } from "firebase/app";
import { getStorage } from 'firebase/storage';
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC5LsWGfEOmhPDKtaM3Cl7kfXW75gZvnPA",
  authDomain: "personal-portfolio-64e2f.firebaseapp.com",
  projectId: "personal-portfolio-64e2f",
  storageBucket: "personal-portfolio-64e2f.appspot.com",
  messagingSenderId: "1056111146511",
  appId: "1:1056111146511:web:dfa723b6cfb87191cbd57a"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

export const storage = getStorage(app);
